// [ai] The KEYMAP on every route: one capture-phase listener so the player answers before the shell (which then sees
// defaultPrevented). Escape closes one layer per press — help › sheet › menu › folders › drawer › drop › player — so with the
// drawer open and no overlay above it, Escape is the shell's.
import { useEffect } from "react";
import { keyAction } from "../core/keys";
import type { StoreApi } from "zustand";
import type { ShellState } from "../stores/shell";
import type { Player } from "./player";
export function usePlayerKeys(player: Player, shell: StoreApi<ShellState>) {
  useEffect(() => {
    const on = (e: KeyboardEvent) => {
      const a = keyAction(e, ev => player.keyActive(ev.key)); if (!a) return;
      const side = shell.getState().side; if (a === "close" && side.open && side.mode === "drawer" && !player.topOverlay()) return;
      e.preventDefault(); player.action(a);
    };
    document.addEventListener("keydown", on, true); return () => document.removeEventListener("keydown", on, true);
  }, [player, shell]);
}
